<template>
    <div @click="$emit('click')" class="checkbox-container">
        <div
            :class="[
        'background',
        { 'is-null': value === null, 'is-on': value === true, 'is-null-loader': showNullLoader }
      ]"
        >
            <div :class="['potard', { 'right': value === true }]"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'checkbox-circle-v2',
    props: {
        value: {
            type: [Boolean, null],
            default: false
        }
    },
    data() {
        return {
            showNullLoader: false
        }
    },
    watch: {
        value(newVal, oldVal) {
            if (newVal === null && oldVal !== null) {
                this.showNullLoader = false
                setTimeout(() => {
                    this.showNullLoader = true
                }, 500)
            } else if (newVal !== null) {
                this.showNullLoader = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.checkbox-container {
    width: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .background {
        width: 46px;
        height: 24px;
        padding: 2px;
        background-color: #D7D9DF;
        border-radius: 16px;
        transition: width 0.5s, background-color 0.5s;

        .potard {
            width: 20px;
            height: 20px;
            background-color: #fff;
            border-radius: 20px;
            transition: margin-left 0.5s;
            margin-left: 0;
        }
    }

    .background.is-null {
        width: 24px;
    }

    .background.is-on {
        background-color: #00D191;

        .potard {
            margin-left: 22px;
        }
    }
}

.is-null-loader {
    background-image: linear-gradient(to bottom, #D7D9DF, #00D191);
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


</style>